import React, { useEffect } from "react";
import { marketValue } from "../../utils/api";

const Price = ({ vin, setTrimValue, setLoader }) => {
	useEffect(() => {
		setLoader(true);
		marketValue(vin)
			.then((res) => {
				setTrimValue(res?.data?.data?.basic.trim.split(" ")[0]);
				setLoader(false);
			})
			.catch(() => setLoader(false));
	}, [vin, setLoader, setTrimValue]);

	return <></>;
};

export default Price;
